import { render, staticRenderFns } from "./workplan_editor.vue?vue&type=template&id=56538cf4"
import script from "./workplan_editor.vue?vue&type=script&lang=js"
export * from "./workplan_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports